import { Typography, Container, Grid } from "@mui/material";
import {
  downloadGradingSheetFileDocx,
  downloadGradingSheetFilePdf,
  downloadInstructionsFileDocx,
  downloadInstructionsFilePdf,
} from "../../utils/file-utils";
import VButton from "../Common/VButton";

const DownloadGuides = (props: { userCode: string }) => {
  return (
    <Container disableGutters sx={styles.rootContainer}>
      <Grid container>
        <Grid item xs={12} md={6} lg={6}>
          <Typography sx={styles.subTitle}>Juhend:</Typography>
          <Container disableGutters sx={styles.buttonsContainer}>
            <VButton text="PDF" onClick={() => downloadInstructionsFilePdf()} sx={styles.button} />
            <VButton text="DOCX" onClick={() => downloadInstructionsFileDocx()} sx={styles.button} />
          </Container>
        </Grid>
        <Grid item xs={12} md={6} lg={6}>
          <Typography sx={styles.subTitle}>Hindamisleht:</Typography>
          <Container disableGutters sx={styles.buttonsContainer}>
            <VButton
              text="PDF"
              onClick={() => downloadGradingSheetFilePdf(props.userCode, new Date())}
              sx={styles.button}
            />
            <VButton
              text="DOCX"
              onClick={() => downloadGradingSheetFileDocx(props.userCode, new Date())}
              sx={styles.button}
            />
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
};

export default DownloadGuides;

const styles = {
  rootContainer: {},
  subTitle: {
    display: "flex",
    justifyContent: "center",
    fontWeight: 700,
    color: "black",
    my: "4%",
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    px: "2%",
  },
  button: {
    mx: "2%",
  },
};
